import { useCloseModal, useConfigureModalController, useModalController } from '@/atoms'
import { useState } from 'react'

type ModalStatus = 'ready'

interface ModalData {
  driverAssignmentIds: string[]
}

type ModalProps = {
  driverAssignmentIds: string[]
}

export const modalId = 'deleteDriverAssignment'
export const useController = () => useModalController<ModalData, ModalStatus>(modalId)

export const useConfigureController = ({ driverAssignmentIds }: ModalProps) => {
  const close = useCloseModal()

  const [options] = useState(() => ({
    createInitialState: () => ({
      status: 'ready' as ModalStatus,
      data: { driverAssignmentIds },
      close,
    }),
  }))

  return useConfigureModalController<ModalData, ModalStatus>(modalId, options)
}
